<template>
    <div :dir="textDirection" class="pilot-program">
        <h3>{{ $t("Template.Banner.Title") }}</h3>
        <p>{{ $t("Template.Banner.BeginningBody") }}</p>
    </div>
</template>
<script>
export default {
    computed: {
        textDirection() {
            var lang = localStorage.getItem("language") || "English"; 
            return lang === "Farsi" ? "rtl" : "ltr";
        }
    }
}
</script>

<style>
.pilot-program {
    background-color: rgb(207, 207, 207);
    padding: .5em 1em;
    box-sizing: border-box;
    color: black;
    margin: 1em 0 0;
}
</style>